// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KYU4","delete":"styles_delete__2NTIE","update":"styles_update__1n9Q0","add":"styles_add__1j4_o"};